import { defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.mjs';
import EventEmitterPackage from 'eventemitter3';

class Disposable {
  constructor(signal) {
    _defineProperty(this, "cancelationError", null);

    this.signal = signal;
    this.eventEmitter = new EventEmitterPackage.EventEmitter();

    this.abortListener = error => {
      this.cancelationError = error;
      this.eventEmitter.emit('cancel', error);
      this.close();
    };

    this.signal.addEventListener('abort', this.abortListener);
  }

  async run(callback, thenCloseDisposable = true) {
    try {
      return await Promise.resolve(callback(this.getScope()));
    } finally {
      if (thenCloseDisposable) {
        this.close();
      }
    }
  }

  getScope() {
    return {
      signal: this.signal,
      isCanceled: () => this.isCanceled(),
      getCancelationError: () => this.cancelationError,
      throwIfCanceled: () => {
        if (this.isCanceled()) {
          throw this.getCancelationError();
        }
      }
    };
  }

  isCanceled() {
    return this.signal.aborted;
  }

  getCancelationError() {
    return this.cancelationError;
  }

  onCancel(callback) {
    this.eventEmitter.on('cancel', callback);
    return this;
  }

  close() {
    this.signal.removeEventListener('abort', this.abortListener);
    this.eventEmitter.removeAllListeners();
  }

}

export { Disposable };
//# sourceMappingURL=Disposable.mjs.map
